import '../scss/index.scss'
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]");
import 'slick-carousel';

import $ from 'jquery';
window.jQuery = $;

import lottie from 'lottie-web';

import Headroom from "headroom.js";
var myElement = document.querySelector("header");

import { disablePageScroll, enablePageScroll } from 'scroll-lock';

var options = {
    classes : {
        // when element is initialised
        initial : "header",
        // when scrolling up
        pinned : "pinned",
        // when scrolling down
        unpinned : "unpinned",
        // when above offset
        top : "top",
        // when below offset
        notTop : "not-top",
        // when at bottom of scroll area
        bottom : "bottom",
        // when not at bottom of scroll area
        notBottom : "not-bottom",
        // when frozen method has been called
        frozen: "frozen",
        // multiple classes are also supported with a space-separated list
        pinned: "pinned"
    },
};

var headroom  = new Headroom(myElement, options);

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function ($) {

    // Set footer position on load (delay handled separately)
    gsap.set('.footer', {
        position: 'sticky',
        bottom: 0,
        left: 0
    });
    
    // Optimized batch animation with initial state setup
    const animatedElements = gsap.utils.toArray(".block, .section__title, .section--video");
    
    // Set initial state for better performance
    gsap.set(animatedElements, {
        autoAlpha: 0,
        y: 30,
        willChange: 'transform, opacity'
    });

    // Batch scroll-triggered animations with optimizations
    ScrollTrigger.batch(animatedElements, {
        onEnter: (batch) => {
            gsap.to(batch, {
                duration: 0.4,
                autoAlpha: 1,
                y: 0,
                stagger: 0.1,
                ease: "power2.out",
                clearProps: "willChange" // Clean up will-change after animation
            });
        },
        start: 'top 90%',
        once: true, // Only animate once for better performance
        invalidateOnRefresh: true // Recalculate on resize
    });

    // Optimize header animations using timeline
    const headerTimeline = gsap.timeline({ defaults: { ease: "power2.out" } });
    
    headerTimeline
        .set(['.header-logo', '.header'], { autoAlpha: 0 })
        .to(['.header-logo', '.header'], { 
            autoAlpha: 1, 
            duration: 0.6 
        }, 0) // Start both at same time
        .to('.header-logo', { 
            clipPath: 'inset(0 0 0 0)', 
            duration: 0.5 
        }, 0.2); // Start slightly after


    headroom.init();
    
    const scrollableElement = document.querySelectorAll('.header, .block--modal');
    
    $('.header__toggle').on('click', function (e) {
        e.preventDefault();
        if($('.open')[0]) {
            enablePageScroll(scrollableElement);
        } else {
            disablePageScroll(scrollableElement);
        }
        
        $('.header').toggleClass('open');
    });
    
    $(document).on('keyup', function(e) {
        if($('.header').hasClass('open')) {
            if (e.key == "Escape") {
                enablePageScroll(scrollableElement);
                $('.header').removeClass('open');
            }
        }
    });
    
    // Sliders
    $('.slider--logos').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        pauseOnHover: false,
        draggable: false,
        rows: 0,
        responsive: [
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false
                }
            },
        ]
    });

    $('.slider--examples').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        rows: 0,
        responsive: [
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 1.1,
                }
            },
        ]
    });
    
    $('.block--tools ul li a').on('mouseover', function () {
        var hover = $(this).attr('data-hover');
        console.log(hover);
        $('.block--tools .block__img').css('opacity', '0');
        $('.' + hover).css('opacity', '1');
    });
    
    $('.open-modal, .block--modal .block__close').on('click', function (e) {
        e.preventDefault();
        if($('.block--modal.open')[0]) {
            enablePageScroll(scrollableElement);
        } else {
            disablePageScroll(scrollableElement);
        }
        $('.overlay').toggleClass('open');
        $('.block--modal').toggleClass('open');
    });
    
    // Optimized modal scroll animation
    if ($('.contact')[0]) {
        const modalContent = document.querySelector('.block--modal .block__content');
        if (modalContent) {
            // Set initial state for better performance
            // Note: willChange kept active for scrubbed animations
            gsap.set(modalContent, {
                willChange: 'transform, margin'
            });
            
            gsap.to(modalContent, {
                scrollTrigger: {
                    trigger: '.block--modal',
                    scroller: '.block--modal',
                    start: "top top",
                    end: "30% top",
                    scrub: 1, // Smooth scrubbing (1 second lag for smoother feel)
                    markers: false,
                    invalidateOnRefresh: true
                },
                marginTop: 0,
                marginLeft: 0,
                marginRight: 0,
                transformOrigin: "bottom",
                ease: "power1.inOut"
            });
        }
    }
    
    // Debounced resize handler for ScrollTrigger refresh
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            ScrollTrigger.refresh();
        }, 250);
    });
    
    // Cleanup ScrollTriggers on page unload for better memory management
    window.addEventListener('beforeunload', () => {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    });
});

if (document.getElementById('vhl')) {
    
    lottie.loadAnimation({
        container: document.getElementById('vhl'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/wp-content/themes/appademic-nl/lottie/drawing-shapes.json',
    });
}

// Enable source maps for debugging
//# sourceMappingURL=main.js.map